import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';

import { ButtonModule } from '../button/button.module';
import { InputModule } from '../input/input.module';
import { IntlInputModule } from '../intl-input/intl-input.module';
import { CurrencyDropdownModule } from '../currency-dropdown/currency-dropdown.module';
import { PlaceholderLoaderModule } from '../placeholder-loader/placeholder-loader.module';
import { PlaceAutocompleteModule } from '../place-autocomplete/place-autocomplete.module';
import { PaymentUtilService } from './services';
import { PayementRoutingModule } from './payment-routing.module';
import { KettoAssuredModule } from '../ketto-assured/ketto-assured.module';
import { DonationConfirmationModule } from '../donation-confirmation/donation-confirmation.module';
import { SharedModule } from '../../shared/shared.module';
import { CaptchaModule } from '../captcha/captcha.module';
import { TipCardModule } from '../tip-card/tip-card.module';
import { CaptchaInputModule } from '../captcha-input/captcha-input.module';
import { SipCardOnPaymentModule } from '../sip-card-on-payment/sip-card-on-payment.module';
import { SipPopupModule } from '../sip-popup/sip-popup.module';
import { KettoAssuredV2Module } from '../ketto-assured-v2/ketto-assured-v2.module';
// import { PaymentOptionV2Module } from '../payment-option-v2/payment-option-v2.module';

import {
  MainComponent, AmountFormComponent, PaymentHeaderComponent,
  OptionsNavComponent, CardsComponent, NetbankingComponent,
  WalletsComponent, PaytmComponent, RewardsComponent,
  SlabsComponent, UpiComponent, UserInfoComponent,
  PaymentLandingComponent,
  UtmWalletHundredComponent, PaymentHeaderStoriesComponent, DonateMoreNudgeComponent
} from './components';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OtdSipToggleModule } from '../otd-sip-toggle/otd-sip-toggle.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { QuickdonateCardModule } from '../quickdonate-card/quickdonate-card.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { QuickDonateCarouselModule } from '../quicdonate_carousel/quicdonate_carousel.module';
import { ComponentLoader } from 'src/app/core/component-loader/component-loader.component';
import { MultiPatientNoteComponent } from '../multi-patient-note/multi-patient-note.component';
import { DonateBtnComponent } from 'src/app/core/donate-btn/donate-btn.component';
import { BulkDonationSelectionComponent } from 'src/app/core/bulk-donation-selection/bulk-donation-selection.component';
import { InViewportModule } from 'ng-in-viewport';
import { BulkDonationSelectionV2Component } from 'src/app/core/bulk-donation-selection-v2/bulk-donation-selection-v2.component';
import { TipSelectNudgeComponent } from 'src/app/core/tip-select-nudge/tip-select-nudge.component';
import { InsureSelectComponent } from 'src/app/core/insure-select/insure-select.component';
import { SipPitchOtdComponent } from 'src/app/core/sip-pitch-otd/sip-pitch-otd.component';
import { GCaptchaModule } from '../g-captcha/g-captcha.module';
import { PhoneNumberInputV2Component } from 'src/app/core/phone-number-input-v2/phone-number-input-v2.component';
import { StripeExpressComponent } from "../../core/stripe-express/stripe-express.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { UpiInputComponent } from 'src/app/core/upi-input/upi-input.component';

/**Payment COmponents */
const PaymentComponents = [
  MainComponent, AmountFormComponent, PaymentHeaderComponent,
  OptionsNavComponent, CardsComponent, NetbankingComponent,
  WalletsComponent, PaytmComponent, RewardsComponent,
  SlabsComponent, UpiComponent, UserInfoComponent,
  PaymentLandingComponent,
  UtmWalletHundredComponent, PaymentHeaderStoriesComponent, DonateMoreNudgeComponent
];
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxMaskModule.forRoot(),
    InputModule,
    IntlInputModule,
    ButtonModule,
    PayementRoutingModule,
    CurrencyDropdownModule,
    PlaceholderLoaderModule,
    PlaceAutocompleteModule,
    KettoAssuredModule,
    DonationConfirmationModule,
    SharedModule,
    CaptchaModule,
    TipCardModule,
    CaptchaInputModule,
    SipCardOnPaymentModule,
    SipPopupModule,
    KettoAssuredV2Module,
    // PaymentOptionV2Module,
    MatSlideToggleModule,
    OtdSipToggleModule,
    ModuleLoaderModule,
    QuickdonateCardModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatOptionModule,
    MatRippleModule,
    MatListModule,
    MatIconModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatButtonModule,
    QuickDonateCarouselModule,
    ComponentLoader,
    MultiPatientNoteComponent,
    DonateBtnComponent,
    InViewportModule,
    BulkDonationSelectionComponent,
    BulkDonationSelectionV2Component,
    TipSelectNudgeComponent,
    InsureSelectComponent,
    SipPitchOtdComponent,
    GCaptchaModule,
    PhoneNumberInputV2Component,
    StripeExpressComponent,
    UpiInputComponent
],
  declarations: [
    ...PaymentComponents,
  ],
  providers: [
    PaymentUtilService
  ],
  exports: [
    MainComponent,
    CardsComponent,
    SlabsComponent,
    OptionsNavComponent,
    PaymentLandingComponent
  ],
  bootstrap: [
    MainComponent
  ]
})
export class PaymentModule {
  getComponent() {
    return MainComponent;
  }
}
